<template lang="pug">
#mcp.tab-pane.fade.show.active
  .mb-2
    label.col-form-label {{ $t('ui.current_password') }} :
    input.form-control(type='password' autocomplete="off" maxlength="20" v-model.trim="$v.oldPassword.$model")
  validation(:value="$v.oldPassword" :name="$t('ui.current_password')" target="CURRENTPW")
  .mb-2
    label.col-form-label {{ $t('ui.new_password') }} :
    input.form-control(type='password' autocomplete="off" maxlength="20" v-model.trim="$v.newPassword.$model")
  validation(:value="$v.newPassword" :name="$t('ui.new_password')" target="NEWPW")
  .mb-2
    label.col-form-label {{ $t('ui.confirm_password') }} :
    input.form-control(type="password" autocomplete="off" maxlength="20" v-model.trim="$v.confirmPassword.$model")
  validation(:value="$v.confirmPassword" :name="$t('ui.confirm_password')" target="CONFIRMPW")
  .mt-4.text-center
    button.btn-submit.text-uppercase(v-if="!loading" type='button' @click.stop="updatePassword") {{ $t('ui.update') }}
    button.btn-submit.disabled-grey(v-else type='button')
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import { required, minLength, maxLength, sameAs, not } from 'vuelidate/lib/validators'
import validation from "@/library/_validation.vue"
export default {
  components: {
    validation
  },
  data(){
    return{
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      feedback:{
        success: true,
        status: ""
      },
      loading:false
    }
  },
  validations:{
    oldPassword:{
      required,
    },
    newPassword:{
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      isValid : not(sameAs('oldPassword')),
      alphaNumCheck: function(value){
        const containsAlphabet = /[A-Za-z]/.test(value)
        const containsNumber = /[0-9]/.test(value)
        return containsAlphabet && containsNumber
      },
    },
    confirmPassword:{
      required,
      sameAsPassword: sameAs('newPassword')
    },
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  beforeDestroy(){
    this.reset()
  },
  methods:{
    reset() {
      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    },
    updatePassword(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let account_id = this.accountID
          let password = this.oldPassword
          let new_password = this.newPassword
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/updatePassword", { account_id, password, new_password, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.change_password_success"), "success", this);
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            });
        }
      }
    }
  }
}
</script>